<div class="bg-white rounded-2xl border border-gray-200 shadow-sm p-4 sm:p-5">
  <app-list-phase-model />
</div>
